/* eslint-disable */
import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import i18n from './i18n/i18nApp'

/*import '@/assets/vendor/fontawesome-kit/js/fontawesome'
import '@/assets/vendor/fontawesome-kit/js/custom-icons'
import '@/assets/vendor/fontawesome-used/light'
import '@/assets/vendor/fontawesome-used/solid'
import '@/assets/vendor/fontawesome-used/regular'*/


//fa-circle-info
const app = createApp(App)
app.use(store)
app.use(i18n)
app.mount('#appDaliLinePlanner')